export default "__VITE_ASSET__BDI3TYPv__"